module.exports = __webpack_public_path__ + "img/_ecp-dagger_.e13f1dff.svg";